export const FETCH_LIST_CITY_SUCCESS = "FETCH_LIST_CITY_SUCCESS";
export const FETCH_LIST_DISTRICT_SUCCESS = "FETCH_LIST_DISTRICT_SUCCESS";
export const FETCH_LIST_WARD_SUCCESS = "FETCH_LIST_WARD_SUCCESS";
